import { WSTableCell } from "@wingspanhq/fe-component-library";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import React from "react";
import { TaxFormSubmissionRow } from "../../../services/search";
import { selector1099NECTotal } from "../selectors/selector1099NECTotal";

export type NEC1099TotalCellProps = {
  taxFormSubmission: TaxFormSubmissionRow;
};

export const NEC1099TotalCell: React.FC<NEC1099TotalCellProps> = ({
  taxFormSubmission
}) => {
  const nec1099Total = selector1099NECTotal(taxFormSubmission);
  let secondaryText;

  if (taxFormSubmission.isGrouped) {
    secondaryText = "Grouped";
  }

  return Number.isFinite(nec1099Total) && nec1099Total !== undefined ? (
    <WSTableCell
      text={formatMoney(nec1099Total, "USD")}
      secondaryText={secondaryText}
    />
  ) : (
    <WSTableCell text="--" />
  );
};
